module.exports = __webpack_public_path__ + "img/1471107378.4cd44b6e.png";